import { PermanentJobsApi } from '../clients';
import { CandidateResumeAdapters } from '../adapters/CandidateResume';
import type { ICandidateResumeEntity } from '../types/CandidateResume';
import type { IGetCandidateResumePayload } from '../types/CandidateResume.parameters';

export const getCandidateResume = async (
  payload: IGetCandidateResumePayload,
): Promise<ICandidateResumeEntity> => {
  const response = await PermanentJobsApi.getCandidateResume(payload);

  return CandidateResumeAdapters.toGetCandidateResumeResult(response);
};
